import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'react-bootstrap';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import UserTables from './UsersData/UserTables';


const Users = () => (
  <div>
    <Breadcrumbs
      aria-label="breadcrumb"
      sx={{
      marginBottom: '5px',
    }}
    >
      <Typography sx={{ color: 'text.primary' }}>Admin</Typography>
      <Typography sx={{ color: 'text.primary' }}>User Manager</Typography>
      <Typography sx={{ color: 'text.primary' }}>Users</Typography>
    </Breadcrumbs>
    <UserTables />
  </div>
  );

export default Users;
